import type { ComponentProps } from 'react'

/** Generated from Penpot `icons / check normal`. Do not edit by hand. */
export function CheckIcon(props: ComponentProps<'svg'>) {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M15.65,2.68C16.12,3.15,16.12,3.9,15.65,4.37L6.65,13.29C6.41,13.53,6.08,13.67,5.74,13.67C5.4,13.67,5.08,13.53,4.84,13.29L0.37,8.86C0.05,8.56,-0.07,8.12,0.04,7.7C0.15,7.28,0.48,6.96,0.89,6.85C1.32,6.74,1.76,6.87,2.06,7.18L5.74,10.83L13.95,2.68C14.18,2.46,14.48,2.33,14.8,2.33C15.12,2.33,15.42,2.46,15.65,2.68" />
    </svg>
  )
}
